import { Equipo } from '@/domain/entities/equipo';
import { EquipoParamsDTO } from '@/application/dto/equipos/EquipoParamsDTO';
import { IEquipoRepository } from '@/domain/repositories/IEquipoRepository';

export class GetEquiposUseCase {
  constructor(
    private readonly repository: IEquipoRepository
  ) {}

  async execute(params?: EquipoParamsDTO): Promise<Equipo[]> {
    return this.repository.getequipos(params);
  }
}